import { cacheMs } from "../constants";

// Het dashboard hangt op een tv en wordt zelden herladen, maar bij het
// wisselen van maand willen we niet steeds opnieuw alles ophalen. Daarom
// bewaren we het laatste antwoord vijf minuten in het geheugen.

let entry = null; // { month, year, data, at }

export function readCache(month, year) {
  if (!entry) return null;
  if (entry.month !== month || entry.year !== year) return null;
  if (Date.now() - entry.at >= cacheMs) return null;
  return entry.data;
}

export function writeCache(month, year, data) {
  entry = { month, year, data, at: Date.now() };
}
